import { render, staticRenderFns } from "./PaymentMethodActionDelete.vue?vue&type=template&id=267e959f&"
import script from "./PaymentMethodActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports